import axios from 'axios';
import Handlers from './handlers'

const API_PATH = 'replacement_vehicle_reservations/';

class replacementVehicleReservationsService {
    create(requestData) {
        const url = API_PATH + 'create';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    delete(spOrder) {
        const url = API_PATH + 'delete';
        return new Promise((resolve, reject) => {
            axios.post(url, spOrder.id)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
	listFiltered(requestData) {
		const url = API_PATH + 'list_filtered';
		return new Promise((resolve, reject) => {
			axios.post(url, requestData)
				.then(response => {
					// handle success
					Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
				})
				.catch(error => {
					// handle error
					Handlers.ERROR_HANDLER(url, error, null, reject);
				});
		});
	}
	vehicleReservationsForMonth(requestData) {
		const url = API_PATH + 'vehicle_reservations_for_month';
		return new Promise((resolve, reject) => {
			axios.post(url, requestData)
				.then(response => {
					// handle success
					Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
				})
				.catch(error => {
					// handle error
					Handlers.ERROR_HANDLER(url, error, null, reject);
				});
		});
	}
	contractExport(requestData) {
        const url = API_PATH + 'contract_export';
        let headers = { 'responseType': 'arraybuffer' }
        return new Promise((resolve, reject) => {
            axios.post(url, requestData, headers)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
	}
	extend(requestData) {
        const url = API_PATH + 'extend';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
	}
}

export default new replacementVehicleReservationsService();